import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Gauge, Zap, Settings2, Leaf, Volume2, Rocket, Wind, Recycle, FlaskConical, Filter, Activity, Droplets, Check, AlertTriangle } from "lucide-react";
import { getProducts } from "@/lib/api";

const ICONS = {
    stage1: Gauge,
    stage2: Zap,
    stage3: Rocket,
    dsg: Settings2,
    eco: Leaf,
    popsbangs: Volume2,
    vmax: Wind,
    agr: Recycle,
    kat: FlaskConical,
    dpf: Filter,
    nox: Activity,
    adblue: Droplets,
};

export const TuningProducts = () => {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        getProducts().then(setProducts).catch(() => setProducts([]));
    }, []);

    return (
        <section id="produkte" className="relative scroll-mt-20 border-t border-border bg-[#0A0A0A] py-24">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
                        Tuning Produkte
                    </span>
                    <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        Optimierungen für jeden Anspruch
                    </h2>
                    <p className="mt-4 text-base text-[#A1A1AA]">
                        Von der Software-Optimierung bis zur Getriebe-Abstimmung. Jede Leistung
                        fahrzeugspezifisch und professionell.
                    </p>
                </div>

                <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {products.map((p, i) => {
                        const Icon = ICONS[p.id] || Gauge;
                        return (
                            <motion.div
                                key={p.id}
                                data-testid={`product-card-${p.id}`}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                                className="card-hover group flex flex-col rounded-xl border border-border bg-surface p-6"
                            >
                                <div className="flex items-start justify-between">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-lg border border-primary/30 bg-primary/10">
                                        <Icon className="h-6 w-6 text-primary" strokeWidth={1.6} />
                                    </div>
                                    <span className="rounded-full bg-success/10 px-3 py-1 text-xs font-semibold text-success">
                                        {p.steigerung}
                                    </span>
                                </div>

                                <h3 className="mt-5 text-xl font-bold text-white">{p.name}</h3>
                                <p className="mt-1 text-sm text-[#A1A1AA]">{p.kurz}</p>
                                <p className="mt-3 text-sm leading-relaxed text-[#71717A]">{p.beschreibung}</p>

                                <ul className="mt-5 space-y-2">
                                    {p.vorteile.slice(0, 3).map((v) => (
                                        <li key={v} className="flex items-center gap-2 text-sm text-white">
                                            <Check className="h-4 w-4 shrink-0 text-success" />
                                            {v}
                                        </li>
                                    ))}
                                </ul>

                                <div className="mt-auto flex items-start gap-2 border-t border-border pt-4 text-xs text-[#71717A]">
                                    <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#F59E0B]" />
                                    <span>{p.hinweise}</span>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default TuningProducts;
